/* tslint:disable */

/**
 */
export class UnitDataEquipment {
    Price?: number;
    IntervalWidth?: number;
    IntervalLength?: number;
    MonetarySymbol?: string;
    DimensionSymbol?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/unit-data-equipment.ts